import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { AbstractApiController } from './abstract-api-controller';
import { DefaultResponseInterface } from '../model/response/default-response.interface';

@Injectable()
export class LogoutApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public logout() {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/personal-area/logout',
      {},
      {headers: this.getAuthHeaders()}
    );
  }
}
